module.exports = __webpack_public_path__ + "static/media/smaller-sauti.08c188e8.png";